import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from '@angular/fire/compat';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material.module';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { XpoLtlAuthConfigLoaderService, XpoLtlAuthModule } from '@xpo-ltl/ngx-auth';
import { XPO_AUTH_CONFIG, XpoAuthConfig } from '@xpo/ngx-auth';
import { AppToolbarComponent } from './components/app-toolbar/app-toolbar.component';
import { ConfirmCancelComponent } from './dialogs/confirm-cancel/confirm-cancel.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { NotificationComponent } from './components/notification/notification.component';
import { SharedServicesModule } from './shared-services.module';

import { CustomerRuleService } from './services/customer-rule/customer-rule.service';
import { UserApiService } from '@xpo-ltl/sdk-user';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { LoggingApiService, SdkLoggingModule } from '@xpo-ltl/sdk-logging';
import { SearchKeyResolver } from './resolvers/search-key-resolver';
import { SdkB2BModule } from '@xpo-ltl/sdk-b2b';
import { ClipboardModule, ClipboardService } from 'ngx-clipboard';
import { XpoBrowserGuardModule } from '@xpo-ltl/ngx-ltl-core/browser-guard';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoFeedbackModule } from '@xpo-ltl/ngx-ltl-core/feedback';
import { VersionBannerComponent } from './components/version-banner/version-banner.component';
import { RegionBannerComponent } from './components/region-banner/region-banner.component';
import { AppDirectivesModule } from './directives/app-directives.module';
import { CustomerApiService } from '@xpo-ltl-2.0/sdk-customer';
import { environment } from '../environments/environment';

export function authConfigFactory(configService: XpoLtlAuthConfigLoaderService): XpoAuthConfig {
  configService.initSettings('./assets/config.json');
  return new XpoAuthConfig({
    appCode: configService.appCode,
    scopes: configService.scopes,
    isProd: configService.isProd,
    applicationRootUri: configService.appRootUri,
  });
}

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    AppFooterComponent,
    AppToolbarComponent,
    ConfirmCancelComponent,
    NotAuthorizedComponent,
    NotificationComponent,
    RegionBannerComponent,
    VersionBannerComponent,
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    BrowserModule,
    BrowserAnimationsModule,
    SharedServicesModule,
    MaterialModule,
    ConfigManagerModule,
    SdkLoggingModule,
    SdkB2BModule,
    ClipboardModule,
    XpoBrowserGuardModule,
    XpoSnackBarModule,
    XpoFeedbackModule,
    XpoShellModule,
    AppDirectivesModule,
    XpoLtlAuthModule.forRoot({
      provide: XPO_AUTH_CONFIG,
      useFactory: authConfigFactory,
      deps: [XpoLtlAuthConfigLoaderService],
    }),
    AppRoutingModule, // keep last
  ],
  providers: [
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json' } },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
    DataApiService,
    NotificationService,
    CustomerApiService,
    CustomerRuleService,
    UserApiService,
    LoggingApiService,
    ClipboardService,
    SearchKeyResolver,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
